import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Chip,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactHookFormMultiSelectChip from "../../../../components/ReactHookFormMultiSelectChip";
import { DataGridContext } from "../../../../context/DataGridContext";
import { getTextColour } from "../../utils";
import { Colours } from "../../../../assets/global/Theme-variable";

export default function NewSiteForm({ methods, gridList, table }) {
  const { control, formState } = useFormContext();
  const { data } = React.useContext(DataGridContext);
  const siteNumbers = Array.from(Array(9999), (e, i) => JSON.stringify(i + 1));

  const allSites = data?.sites?.map(
    (site) =>
      site.site_isDeleted === 0 &&
      // server.server_number !== "419" &&
      site.site_number
  );

  const siteNumberOptions = siteNumbers.filter(
    (number) => !allSites.includes(number)
  );
  return (
    <>
      <Box
        sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3 }}
      >
        <Box>
          <Controller
            render={({ field: { onChange, value, ref, onBlur }, ...props }) => (
              <Autocomplete
                key={`autocomplete_`}
                options={siteNumberOptions}
                // freeSolo
                value={value || null}
                isOptionEqualToValue={(o, v) => o === v}
                // disableClearable
                sx={{ width: "100%" }}
                size="small"
                // getOptionLabel={(o) => o ?? ''}
                onChange={(event, newValue) => onChange(newValue)} 
                renderInput={(params) => (
                  <TextField
                    required
                    sx={{ width: "100%", marginTop: 1 }}
                    {...params}
                    label={"Number"}
                    variant={"outlined"}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            )}
            name={`site_number`}
            rules={{
              required: {
                value: true,
                message: "Site Number is required",
              },
            }}
          />

          {formState?.errors?.site_number && (
            <Typography sx={{ fontSize: 12, color: Colours.red }}>
              {formState?.errors?.site_number?.message}
            </Typography>
          )}
        </Box>
        <Box>
          <Controller
            control={control}
            render={({
              field: { name, onChange, defaultValue, onBlur, value, ref },
            }) => (
              <TextField
                id="site-name"
                label="Name"
                value={value}
                name={name}
                onChange={onChange}
                size="small"
                sx={{ width: "100%" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
            // name="plu_name"
            name={`site_name`}
            // defaultValue=""
            rules={{
              required: { value: true, message: "Name is required" },
              pattern: {
                //eslint-disable-next-line
                value: /^[-a-zA-Z0-9@\s\*&+%£=!:;><)?(^\[\]{\}\\\/\.\_]+$/,
                message: "Name cannot contain emoji's or special characters",
              },
              maxLength: {
                value: 40,
                message: "Name must be less than 10 characters",
              },
              // validate: (value) => {
              // 	return (
              // 		!data?.items?.some((item) => item?.plu_name === value) ||
              // 		"An item with this name already exists"
              // 	);
              // },
            }}
          />

          {formState?.errors?.site_name && (
            <Typography sx={{ fontSize: 12, color: Colours.red }}>
              {formState?.errors?.site_name?.message}
            </Typography>
          )}
        </Box>
        <Controller
          control={control}
          render={({
            field: { name, onChange, defaultValue, onBlur, value, ref },
          }) => (
            <ReactHookFormMultiSelectChip
              id="userType_role"
              name="site_details[pricebands]"
              label="Pricebands"
              control={control}
              defaultValue={""}
              selectoptions={data?.priceband?.filter(
                (i) => i?.priceband_isDeleted === 0
              )}
              nameToShow={"priceband_name"}
              fieldValueToSave="priceband_ref"
            />
          )}
          name={`site_details.pricebands`}
        />
      </Box>

      <Controller
        name={`site_details.tags`}
        control={control}
        render={({ field: { name, onChange, onBlur, value, ref } }) => (
          <Autocomplete
            multiple
            size="small"
            limitTags={4}
            options={data?.tags
              ?.filter((i) => i?.tag_isDeleted === 0)
              .map((tag) => tag.tag_ref)}
            // shrink
            sx={{ width: "100%" }}
            // displayEmpty
            // InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Tags"
                placeholder="Search"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-", // disable autocomplete and autofill
                }}
              />
            )}
            renderOption={(props, item) => {
              const option = data?.tags?.find((t) => t?.tag_ref === item);
              return (
                <li {...props} key={option.tag_ref}>
                  <ListItemText>{option.tag_name}</ListItemText>
                </li>
              );
            }}
            renderTags={(value, getTagProps) =>
              value?.map((option, index) => {
                const tag = data?.tags?.find((t) => t?.tag_ref === option);
                return (
                  <Chip
                    label={
                      <Typography
                        style={{
                          whiteSpace: "normal",
                          color:
                            getTextColour(tag?.tag_details?.styling?.colour)
                              ?.colour || "black",
                          fontSize: 12,
                        }}
                      >
                        {tag?.tag_name}
                      </Typography>
                    }
                    {...getTagProps({ index })}
                    deleteIcon={
                      <CloseIcon
                        color={
                          getTextColour(tag?.tag_details?.styling?.colour)
                            ?.colour || "white"
                        }
                      />
                    }
                    sx={{
                      // height: "100%",
                      backgroundColor: tag?.tag_details?.styling?.colour,
                      padding: "2px 4px 2px 8px",
                      borderRadius: 2,

                      "& svg": {
                        fontSize: "12px",
                        cursor: "pointer",
                        padding: "4px",
                        color: `${
                          getTextColour(tag?.tag_details?.styling?.colour)
                            ?.colour
                        } !important`,
                      },
                    }}
                  />
                );
              })
            }
            onChange={(event, selectedOptions) => {
              onChange(selectedOptions);
            }}
            onBlur={onBlur}
            value={value}
          />
        )}
      />
    </>
  );
}
